import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Input,
    OnDestroy,
    OnInit,
    Output,
    ViewChild,
    ViewEncapsulation
} from "@angular/core";
import {IncludedPortfoliosGridLayoutService} from "./rebalance-included-portfolio.grid-layout";
import {AppService} from "@irb/app.service";
import {CalltoactionService} from "@irb/irb-common/components/calltoaction/calltoaction.service";
import {IrbEditorsService} from "@irb/irb-editors/irb-editors.service";
import {ISmartFilterDto} from "@irb/irb-editors/irb-editors.model";
import {IrbEditorsEvents} from "@irb/irb-editors/irb-editors.events";
import {IEvent, IEventSubscriber, IrbAppEvents, IrbRebalanceEvents, IrbSettingsEvents} from "@irb/irb-common/events";
import {IDropdownItem} from '@irb-common/models/dropdown.model';
import {UtilityService} from "@irb/irb-common/services/utility.service";
import {IAnalysisPortfolioDTO} from "../irb-rebalance.model";
import {CellClickedEvent, CellValueChangedEvent} from 'ag-grid-community';
import {IAlertDialogData} from "@irb/app.model";
import {ReplaySubject, Subscription, interval} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {IrbSettingsService} from "@irb/irb-settings/irb-settings.service";
import {IGlobalSettings} from "@irb/irb-settings/irb-settings.model";

@Component({ standalone: false,
    selector: "included-portfolio",
    templateUrl: "./rebalance-included-portfolio.component.html",
    styleUrls: ["./rebalance-included-portfolio.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    encapsulation: ViewEncapsulation.None
})
export class RebalanceIncludedPortfolioComponent implements OnInit, OnDestroy, IEventSubscriber {
    gridOptions: any;
    grid: any;
    gridHeight: string = "150px";
    rowCount: number = 0;
    rowCountText: any;
    regex: RegExp = /^\d+$/;
    @ViewChild("portfolioDropdown") portfolioDropdown: any;
    portfolioDropdownData: Array<IDropdownItem> = [];
    portfolioTargets: Array<IDropdownItem> = [];
    @ViewChild("modelDropDown") modelDropDown: any;
    modelDropdownData: Array<IDropdownItem> = [];
    modelTargets: Array<IDropdownItem> = [];
    //modelAllSelected: boolean = false;
    @ViewChild("categoryDropdown") categoryDropdown: any;
    categoryDropdownData: Array<IDropdownItem> = [];
    categoryTargets: Array<IDropdownItem> = [];
    // catAllSelected: boolean = false;
    // noRowsOverLay: any = "<span class='ag-overlay-loading-center ag-overlay-message'>No Included Portfolios</span>";
    loadingOverlayComponentParams: any;
    deletedRecords: Array<any> = [];

    /* fields for dropdowns */
    portfolioIds: any = [];
    modelIds: any = [];
    categoryIds: any = [];
    modelUpdated:boolean;
    /* fields for dropdowns */

    hideImportExtraCashAndColDefs: boolean = false;

    eventSubscription: Subscription;
    private destroyed$: ReplaySubject<boolean> = new ReplaySubject(1);

    enableSelectAllPortfoliosFlag: boolean = false;
    disableAddPortFolio: boolean = false;
    @Input() data: any;
    @Output() dataChange: EventEmitter<any> = new EventEmitter<any>();
    isModelBlank:boolean =false;
    isCategoryBlank:boolean=false;
    isExpandedAll: boolean = false;
    isCollapsedAll: boolean = true;
    private removeTmplArr: any = [];
    private addUnpackedDataArr: any = [];
    private incrementedAccountsCalls = 0;
    gridWidth: any = '1250px';
    isUnitTest: boolean = false;
    frameworkComponents: any;
    portfolioCustLabelAbbr: string;
    globalSettings: IGlobalSettings;
    checkGetPortfoliosRebalSub: Subscription;

    constructor(
        private gls: IncludedPortfoliosGridLayoutService,
        private as: AppService,
        private ctas: CalltoactionService,
        private ies: IrbEditorsService,
        private util: UtilityService,
        private iss: IrbSettingsService
    ) {
        this.eventSubscription = this.as.getEvents().pipe(takeUntil(this.destroyed$)).subscribe((s) => {
            this.processEvent(s);
        });
        this.enableSelectAllPortfoliosFlag = false;
        this.frameworkComponents = this.gls.getFrameworkComponents();
    }

    ngOnDestroy(): void {
        this.destroyed$.next(true);
        this.destroyed$.complete();
    }

    loadGridConditionally() {
        let isTLH = (this.data.analysisType === "Harvest tax losses" || this.data.analysisType === "Tax Loss Harvest");
        const cols: any = (isTLH) ? this.gls.getHarvestTaxLossColoumnDefs(this) : this.hideImportExtraCashAndColDefs ? this.gls.getColumnDefs(this) : this.gls.getColumnDefsPortFStatus(this);

        this.gridOptions = {
            suppressAggFuncInHeader: true,
            getRowId: (params: any) => params && params.data && params.data.portfolioId ? params.data.portfolioId : params.data.accountNumber ? params.data.accountNumber : null,
            treeData: true,
            getDataPath: (data: any) => data.portfolioNameGroup,
            treeDataDisplayType:'custom',
            columnDefs: cols,
            rowSelection: 'multiple',
            overlayNoRowsTemplate: "No Included Portfolios",
            context: {componentParent: this},
            isExternalFilterPresent: this.isExternalFilterPresent.bind(this),
            doesExternalFilterPass: this.doesExternalFilterPass.bind(this),
            onExpandOrCollapseAll: this.onExpandOrCollapseAll.bind(this),
            onCellClicked:  this.onIncludedPortfoliosGridCellClicked.bind(this),
            floatingFilter: false
        };
        if (isTLH) {
            this.gridOptions.onCellValueChanged = (p:CellValueChangedEvent<any, any>) => this.cellValueTLHChanged(p);
        }

        this.isUIAllPortSelected();
        this.dataChange.emit(true);
    }

    isUIAllPortSelected(){
        if(this.data.isUIAllPort === true){
            this.gridOptions.overlayNoRowsTemplate = "All Portfolios Assigned";
            this.disableAddPortFolio = true;
        } else {
            this.gridOptions.overlayNoRowsTemplate = "No Included Portfolios";
            this.disableAddPortFolio = false;
        }
    }

    onGridReady(params: any) {
        const self = this;
        this.grid = params;
        this.deletedRecords = [];
        this.grid.api.addEventListener('rowGroupOpened', this.rowGroupOpened.bind(this));
        const isChildrequired:boolean = this.hideImportExtraCashAndColDefs;
        const unpackdata = this.unpackdata(this.data.smartFilterDto.analysisPortDtoList, isChildrequired);
        this.grid.api.applyTransaction({ add: unpackdata });
        setTimeout( () => {
            if (self && self.grid  && self.grid.api) {
                unpackdata.forEach((data: any) => {
                    const analysisAccountDtoList = self.gls.mapAnalysisAccountDtoList.get(data.portfolioId?.toString());
                    if (analysisAccountDtoList && analysisAccountDtoList.length) {
                        const TempChild = self.grid.api.getRowNode(data.portfolioId + 'TempChild');
                        if (TempChild) {
                            self.applyTransactionAsync({remove: [TempChild.data]}, false);
                            self.applyTransactionAsync({add: analysisAccountDtoList}, false);
                            // const node = self.grid.api.getRowNode(data.portfolioId);
                            // node.setExpanded(true);
                        }
                    }
                });
                this.setExpandedorCollapsedAll();
            }
        },0);

        this.setRowCount();
        this.updateGridHeight();
    }

    updateGridHeight() {
        const tr = this.grid.api.getDisplayedRowCount();

        if (tr === 0) {
            this.gridHeight = "100px";
        } else if (tr > 20) {
            this.gridHeight = "600px";
        } else {
            const p = 90 + (tr * 32);
            this.gridHeight = p + "px";
        }
    }

    onExpandOrCollapseAll(event: any) {
        if (event.source === "expandAll" && this.grid && this.grid.api) {
            let TempChild, arrTemplates: any = [];
            this.grid.api.forEachNode((rowNode: any) => {
                TempChild = this.grid.api.getRowNode(rowNode.data.portfolioId + 'TempChild');
                if (TempChild) {
                    let tmplItem: any = {portfolioId: rowNode.data.portfolioId, tempChildData:TempChild.data};
                    arrTemplates.push(tmplItem);
                }
            });
            if (arrTemplates.length) {
                this.grid.api.showLoadingOverlay();
                this.removeTmplArr = [];
                this.addUnpackedDataArr = [];
                this.incrementedAccountsCalls = 0;
                for (let i = 0; i < arrTemplates.length; i ++) {
                    this.getAcctDetailRowData(arrTemplates[i].portfolioId, arrTemplates[i].tempChildData, arrTemplates.length);
                }
            }
        }
    }

    rowGroupOpened(event:any){
        const TempChild = this.grid.api.getRowNode(event.data.portfolioId + 'TempChild');

        if(event && event.type === "rowGroupOpened" && TempChild){
            this.grid.api.showLoadingOverlay();
            this.removeTmplArr = [];
            this.addUnpackedDataArr = [];
            this.incrementedAccountsCalls = 0;
            this.getAcctDetailRowData(event.data.portfolioId, TempChild.data, 1);
            this.grid.api.redrawRows({rowNodes: [event.node]});
        } else {// do not redraw all parent/child rows only one column
            let p = {
                force: true,
                suppressFlash: false,
                columns: ['accountNumber']
            };
            if (this.grid && this.grid.api)
                this.grid.api.refreshCells(p);
        }


        //this.updateGridHeight();
        this.setExpandedorCollapsedAll();
    }

    getAcctDetailRowData(portfolioId: any, TempChildData:any, totalAccountsCalls: number){
        let dataInputForAccountsCall = {
            Package: this.data.analysisId?this.data.analysisId.toString():null,
            PackageType: this.data.analysisType,
            Portfolio: portfolioId.toString()
        };
        this.ies.getAccountDetailsRebal(dataInputForAccountsCall).subscribe((data: any) => {
            const responseData = data.responseData;
            let unpackdata:Array<any> = [];
            for(var i=0;i<responseData.length;i++){
                let childItem = responseData[i];
                childItem['portfolioNameGroup'] = childItem.parentChildAssociation;
                if(childItem.isLiquidate === true){
                    childItem.extraCashAmount = childItem.accountMarketValue;
                }
                unpackdata.push(childItem);
            }
            this.gls.mapAnalysisAccountDtoList.set(dataInputForAccountsCall.Portfolio, unpackdata);
            this.removeTmplArr.push(TempChildData);
            this.addUnpackedDataArr = this.addUnpackedDataArr.concat(unpackdata);
            this.reDrawGridWithAccounts(totalAccountsCalls);
        }, () => {
            this.reDrawGridWithAccounts(totalAccountsCalls);
        });
    }
    reDrawGridWithAccounts(totalAccountsCalls: number) {
        this.incrementedAccountsCalls++;
        if (totalAccountsCalls === this.incrementedAccountsCalls) {
            if (this.removeTmplArr.length) {
                this.applyTransactionAsync({remove: this.removeTmplArr}, true);
                this.applyTransactionAsync({add: this.addUnpackedDataArr}, true);
            }
            setTimeout(() => {
                if (this.grid && this.grid.api) {
                    this.updateGridHeight();
                    if (this.grid.api.hideOverlay)
                        this.grid.api.hideOverlay();
                }
            }, 250);
        }
    }

    applyTransactionAsync(items:any, async:boolean) {
        async?this.grid.api.applyTransactionAsync(items):this.grid.api.applyTransaction(items);
    }

    getSelectedRows() {
    }

    load(data: any) {
        const unpackdata:Array<any> = [];
        if(data){
            for(let i = 0; i < data.length; i++){
                const item = data[i];
                item['extraCashAmount'] = item.pfExtraCash;
                item['portfolioNameGroup'] = [item.portfolioName];
                item.isNew = true;

                unpackdata.push(item);

                if(data[i].acctQty && this.hideImportExtraCashAndColDefs){
                    const childItem = {
                        portfolioId:item.portfolioId + 'TempChild',
                        portfolioNameGroup:[item.portfolioName,1],
                        extraCashAmount:0
                    };
                    unpackdata.push(childItem);
                }
            }
        }

        this.grid.api.applyTransaction({ add: unpackdata });
        this.setExpandedorCollapsedAll();

        setTimeout(() => {
            this.setRowCount();
        });
    }

    packdata() {
        const unpackdata: Array<any> = [];

        this.grid.api.forEachNode((rowNode:any) => {
            unpackdata.push(rowNode.data);
        });

        this.data.smartFilterDto.analysisPortDtoList = unpackdata.filter((x: any) => !x.isUIdeleted && (typeof x.portfolioId === "number" || (x.portfolioId && !x.portfolioId.endsWith('TempChild'))));

        this.data.smartFilterDto.analysisPortDtoList.forEach((item: any) => {
            delete item.portfolioNameGroup;
        });
    }

    unpackdata(data:any,isTempChildReq:boolean) {
        const unpackdata:Array<any> = [];
        if (!data) { return unpackdata; }
        for(let i=0;i<data.length;i++){
            const item = data[i];
            item['extraCashAmount'] = item.pfExtraCash;
            item['portfolioNameGroup'] = [item.portfolioName];
            unpackdata.push(item);
            if(data[i].acctQty && isTempChildReq){
                const childItem = {portfolioId:item.portfolioId + 'TempChild',portfolioNameGroup:[item.portfolioName,1],extraCashAmount:item.pfExtraCash};
                unpackdata.push(childItem);
            }
        }
        return unpackdata;
    }

    getRowData() {
        let gridData:Array<any> = [];
        this.grid.api.forEachNode((rowNode:any) => {
            const parentData = JSON.parse(JSON.stringify(rowNode.data));//its for a deep copy
            const portfolioId = parentData.portfolioId;
            if(Number(portfolioId)){
                parentData.pfExtraCash = parentData.extraCashAmount;
                delete parentData.portfolioNameGroup;
                delete parentData.extraCashAmount;
                const selectedGroup = this.grid.api.getRowNode(parentData.portfolioId);
                let res:Array<any> = [];
                if(selectedGroup.childrenAfterGroup){
                    for(let i = 0; i < selectedGroup.childrenAfterGroup.length; i++){
                        const childItem =selectedGroup.childrenAfterGroup[i].data;
                        if(!childItem.portfolioId){
                            delete childItem.portfolioNameGroup;
                            if(childItem.isLiquidate === true){
                                delete childItem.extraCashAmount;
                            }
                            res.push(selectedGroup.childrenAfterGroup[i].data);
                        }
                    }
                }
                parentData.analysisAccountDtoList = res;
                gridData.push(parentData);
            }
        });
        return gridData.concat(this.deletedRecords);
    }

    processEvent(event: IEvent) {
        switch (event.type) {
            case IrbEditorsEvents.REFRESH_HARVEST_TAX_LOSS_GRID:
                this.refreshHarvestTaxLossGrid(event);
                break;
            case IrbEditorsEvents.REFRESH_INCLUDED_PORTFOLIO_GRID:
                this.refreshForImportExtraCashSettings(event);
                break;
            case IrbRebalanceEvents.SCHEDULED_REBALANCE:
                this.enableSelectAllPortfolios(event);
                break;
            case IrbRebalanceEvents.SCHEDULED_REBALANCE_NOW:
                this.onScheduleRebalanceFrequencyNow(event);
                break;
            case IrbEditorsEvents.SAVE_MULTIPLE_PORTFOLIOS:
                this.addMultiplePortfolios(event);
                break;
            case IrbEditorsEvents.REFRESH_LOSS_PRIORITY_GRID:
                this.refreshForImportLossPrioritySettings(event);
                break;
            case IrbSettingsEvents.UPDATE:
                this.updateGlobalSettings(event.data);
                break;
        }
    }

    updateGlobalSettings(_data: IGlobalSettings) {
        this.portfolioCustLabelAbbr = _data.portfolioCustLabelAbbr;
    }

    addMultiplePortfolios(event: any) {
        this.portfolioTargets = [];
        this.grid.api.showLoadingOverlay();
        setTimeout(() => this.addMultiplePortFoliosToGrid(event.data.selectedPortfolios));
    }

    ShowMultiplePortFolioSelection() {
        let dataInputForMultipleSelection:any=[];
        this.grid.api.forEachNode(function(node:any){
            dataInputForMultipleSelection.push(node.data);

        });
        this.as.fireEvent(IrbEditorsEvents.SHOW_MULTIPLE_PORTFOLIO_SELECTION_DIALOG,{data:dataInputForMultipleSelection});
    }

    enableSelectAllPortfolios(event: any) {
        if (event.data === "Daily" || event.data === "Weekly" || event.data === "Monthly") {
            this.enableSelectAllPortfoliosFlag = true;
        } else {
            this.enableSelectAllPortfoliosFlag = false;
            this.disableAddPortFolio = false;
            this.onSelectAllPortFolios({checked:false});
        }
    }

    onScheduleRebalanceFrequencyNow(event: any) {
        if (event.data === "Daily" || event.data === "Weekly" || event.data === "Monthly") {
            if (!(this.data.analysisType === "Manual adjustment") && !(this.data.analysisType === "Covered call") ) {
                this.enableSelectAllPortfoliosFlag = true;
            } else {
                this.enableSelectAllPortfoliosFlag = false;
                if(this.data.isUIAllPort) {
                    this.data.isUIAllPort = false;
                    this.onSelectAllPortFolios({checked:false});
                }

            }
        } else {
            this.enableSelectAllPortfoliosFlag = false;
            if(this.data.isUIAllPort) {
                this.data.isUIAllPort = false;
                this.onSelectAllPortFolios({checked:false});
            }
        }
    }

    showImportLossPrioritySettingsDialog() {
        this.as.fireEvent(IrbEditorsEvents.SHOW_IMPORT_LOSS_PRIORITY_SETTINGS_DIALOG,this.data.analysisId ? this.data.analysisId : -9999);
    }

    refreshHarvestTaxLossGrid(event: IEvent) {
        const nodes: any = [];

        this.grid.api.forEachNode((n:any) => {
            if (n.data.portfolioId === event.data.data.portfolioId) {
                n.data.htlAmount = event.data.amount;
                n.data.lossPrty = event.data.lossPriority;
                n.data.portfolioNameGroup = [n.data.portfolioName];
                nodes.push(n.data);
            }
        });
        
        this.grid.api.applyTransaction({ update: nodes });
        this.grid.api.redrawRows();
        this.dataChange.emit(true);
    }

    private checkIfModelExists(md: any, modelId: any) {
        const existsArr = md.filter((item: any) => {
            return item.value.toString() === modelId.toString();
        });
        return existsArr.length > 0;
    }

    ngOnInit() {
        this.hideImportExtraCashAndColDefs = !(this.data.analysisType === "Adjust securities" || this.data.analysisType === "Manual adjustment" || this.data.analysisType === "Replace securities" || this.data.analysisType === "Covered call" || this.data.analysisType === 'Harvest tax losses' || this.data.analysisType === 'Tax Loss Harvest' || this.data.analysisType === 'Invest cash only');
        this.loadGridConditionally();

        this.gridWidth = '1250px';
        if (!this.hideImportExtraCashAndColDefs && this.data.analysisType !== 'Harvest tax losses' && this.data.analysisType !== 'Tax Loss Harvest')
            this.gridWidth = '390px';

        this.ies.getPortFoliosDropDown().subscribe((data: any) => {
            this.portfolioDropdownData = data.items;
        });
        let md: any = [], mdname: string;
        let categoryArray : any = [];
        if(this.data.smartFilterDto && this.data.smartFilterDto.sfModelDtoList){
            this.data.smartFilterDto.sfModelDtoList.forEach((model: any) => {
                if (!this.checkIfModelExists(md, model.modelId)) {
                    md.push({name: model.modelName, value: model.modelId});
                    this.modelIds.push({modelId: model.modelId});
                }
             });
             if(md.length !== 0){
                this.modelTargets.push(md);
             }
        }
        if(this.data.smartFilterDto && this.data.smartFilterDto.sfCategoryDtoList){
            this.data.smartFilterDto.sfCategoryDtoList.forEach((catagory: any) => {
                categoryArray.push({name: catagory.categoryName, value: catagory.categoryId});
                this.categoryIds.push({categoryId: catagory.categoryId});
             });

             if(this.data.smartFilterDto.isCategoryBlank) {
                categoryArray.push({name: "(none)", value: 0});
                this.categoryIds.push({categoryId: 0});
             }
            
             if(categoryArray.length !== 0){
                this.categoryTargets.push(categoryArray);
             }
        }
        if (this.data && this.data.modelId) {
            let md1: any = [];
        if (Array.isArray(this.data.modelId)) {
            for (let i = 0; i < this.data.modelId.length; i++) {
                if (!this.checkIfModelExists(md, this.data.modelId[i])) {
                    mdname = this.data.modelName && this.data.modelName[i] ? this.data.modelName[i] : '';
                    md.push({name: mdname, value: this.data.modelId[i]});
                    md1.push({name: mdname, value: this.data.modelId[i]});
                }
            }
        } else {
            if (!this.checkIfModelExists(md, this.data.modelId)) {
                mdname = this.data.modelName ? this.data.modelName : '';
                md.push({name: mdname, value: this.data.modelId});
                md1.push({name: mdname, value: this.data.modelId});
            }
        }
        if (this.modelTargets.length === 0) {
            this.modelTargets.push(md);
        } else {
            this.modelTargets = this.modelTargets.concat(md1);
        }
    }
    this.ies.getModelsRebal().subscribe((data: any) => {
        this.loadModelsDropDown(data.responseData);
        if (md) {
            if(this.modelDropdownData && this.modelDropdownData.length > 0) {
                for(let i =0;i<md.length;i++) {
                    let modelItem:IDropdownItem = md[i];
                    let selectedModel =  this.modelDropdownData.find((x:IDropdownItem)=> x.value === modelItem.value);
                    if(selectedModel) {
                        modelItem.name = selectedModel.name;
                    }
                }
                if(md.length !==0) {
                    this.modelTargets = [].concat(...md);
                }
            }
            this.modelDropDown.setValue(md);

            delete this.data.modelId;
            delete this.data.modelName;
            this.dataChange.emit(this.data);
        }
    });
    this.ies.getCustomCategoriesRebal().subscribe((data: any) => {
        this.loadCategoriesDropDown(data.responseData);
        if (categoryArray) {
            if(this.categoryDropdownData && this.categoryDropdownData.length > 0) {
                for(let i =0;i<categoryArray.length;i++) {
                    let categoryItem:IDropdownItem = categoryArray[i];
                    let selectedCategory =  this.categoryDropdownData.find((x:IDropdownItem)=> x.value.toString() === categoryItem.value.toString());
                    if(selectedCategory) {
                        categoryItem.name = selectedCategory.name;
                    }
                }
                if(categoryArray.length !==0) {
                    this.categoryTargets = [].concat(...categoryArray);
                }
            }
            this.categoryDropdown.setValue(categoryArray);
        }
    });
    if(this.data && this.data.smartFilterDto && this.data.smartFilterDto.modelUpdated) {
        this.modelUpdated = true;
    } else {
        this.modelUpdated = false;
    }

    this.iss.getGlobalSettings().subscribe((globalSettings: any) => {
        this.globalSettings = globalSettings;
        this.portfolioCustLabelAbbr = this.globalSettings.portfolioCustLabelAbbr;
    });
}

    getPortfolios(searchStr: any) {
        let f: Array<IDropdownItem> = [];

        if (searchStr) {
            const r = new RegExp(searchStr, "gi");

            this.portfolioDropdownData.forEach((item: IDropdownItem) => {
                if (item.name?.match(r)) {
                    f.push(item);
                }
            });
        } else {
            f = [].concat(this.portfolioDropdownData);
        }

        this.portfolioDropdown.set(JSON.parse(JSON.stringify(f)));
    }

    onPortfolioChange(s: Array<IDropdownItem>) {
        this.portfolioTargets = s;
    }

    hasPortfolioTargets() {
        return this.portfolioTargets !== null && this.portfolioTargets.length > 0;
    }

    getModels(searchStr: any) {
        let f: Array<IDropdownItem> = [];

        if (searchStr) {
            const r = new RegExp(searchStr, "gi");

            this.modelDropdownData.forEach((item: IDropdownItem) => {
                if (item.name.match(r)) {
                    f.push(item);
                }
            });
        } else {
            f = [].concat(this.modelDropdownData);
        }

        this.modelDropDown.set(JSON.parse(JSON.stringify(f)));
    }

    onModelChange(s: Array<IDropdownItem>) {
        this.modelIds = [];
        this.modelTargets = s;
        this.isModelBlank = false;
        if (this.modelTargets && this.modelTargets.length > 0) {
            for (let i = 0; i < this.modelTargets.length; i++) {
                if (this.modelTargets[i].value != 0) {
                    this.modelIds.push({modelId: this.modelTargets[i].value});
                } else {
                    this.isModelBlank = true;
                }
            }
        }
    }

    getCategories(searchStr: any) {
        let f: Array<IDropdownItem> = [];

        if (searchStr) {
            const r = new RegExp(searchStr, "gi");

            this.categoryDropdownData.forEach((item: IDropdownItem) => {
                if (item.name.match(r)) {
                    f.push(item);
                }
            });
        } else {
            f = [].concat(this.categoryDropdownData);
        }

        this.categoryDropdown.set(JSON.parse(JSON.stringify(f)));
    }

    oncategoryChange(s: Array<IDropdownItem>) {
        this.categoryTargets = s;
        this.categoryIds = [];
        this.isCategoryBlank = false;
        if (this.categoryTargets && this.categoryTargets.length > 0) {
            for (let i = 0; i < this.categoryTargets.length; i++) {
                if(this.categoryTargets[i].value!=0) {
                    this.categoryIds.push({categoryId: this.categoryTargets[i].value});
                } else {
                    this.isCategoryBlank = true;
                }
            }
        }
    }

    loadModelsDropDown(data: any) {
        if (!data) {
            return;
        }

        for (let i = 0; i < data.items.length; i++) {
            this.modelDropdownData.push({name: data.items[i].name, value: data.items[i].id});
        }

        this.util.sortByKey(this.modelDropdownData, "name", "asc");
        this.modelDropdownData.unshift({name:"(none)",value:0});
    }

    loadCategoriesDropDown(data: any) {
        if (!data) {
            return;
        }

        for (let i = 0; i < data.items.length; i++) {
            this.categoryDropdownData.push({name: data.items[i].name, value: Number(data.items[i].id)});
        }

        this.util.sortByKey(this.categoryDropdownData, "name", "asc");
        this.categoryDropdownData.unshift({name:"(none)",value:0});
    }
    
    onSelectAllPortFolios(event: any) {
        this.disableAddPortFolio = event.checked;
        const portfolioIdList: any = [];
        
        let s = this.disableAddPortFolio ?  "All Portfolios Assigned" : "No Included Portfolios";
        this.gridOptions.overlayNoRowsTemplate = s;

        this.grid.api.forEachNode((rowNode:any) => {
            const parentData = rowNode.data;
            const portfolioId = Number(parentData.portfolioId);
            if(portfolioId){
                portfolioIdList.push(portfolioId);
            }
        });

        this.removeSelected(portfolioIdList);
        this.updateGridHeight();
        this.data.smartFilterDto.analysisPortDtoList = [];
        this.setRowCount();
        this.dataChange.emit(this.data);
        if (event.checked) {
            this.modelDropDown.setValue(null);
            this.categoryDropdown.setValue(null);
            this.data.smartFilterDto.isCategoryAll = false;
            this.data.smartFilterDto.isModelAll = false;
            this.data.smartFilterDto.isModelBlank = false;
            this.data.smartFilterDto.modelUpdated = false;
            this.data.smartFilterDto.smartFilterDays = null;
            this.data.smartFilterDto.sfModelDtoList = [];
            this.data.smartFilterDto.sfCategoryDtoList = [];
            this.modelIds = [];
            this.categoryIds = [];
            this.isModelBlank = false;
            this.isCategoryBlank = false;
        }
    }

    onSelectPortFoliosModels(event: any){
        if(event.checked){
            this.data.smartFilterDto.smartFilterDays = null;
        }
    }
    showImportExtraCashDialog() {
        this.as.fireEvent(IrbEditorsEvents.SHOW_IMPORT_EXTRA_CASH_SETTINGS,this.data.analysisId?this.data.analysisId:-9999,);
    }
    initSmartFilterDto() {
        this.data.smartFilterDto = {} as ISmartFilterDto;
        this.data.smartFilterDto.isCategoryAll = false;
        this.data.smartFilterDto.isModelAll = false;
        this.data.smartFilterDto.isModelBlank = false;
        this.data.smartFilterDto.modelUpdated = false;
        this.data.smartFilterDto.smartFilterDays = null;
        this.data.smartFilterDto.sfModelDtoList = this.modelIds || [];
        this.data.smartFilterDto.sfCategoryDtoList = this.categoryIds || [];
        this.data.smartFilterDto.analysisPortDtoList = [];
    }

    deleteAll() {
        const portfolioIdList: any = [];

        this.grid.api.forEachNode((rowNode:any) => {
            const parentData = rowNode.data;
            const portfolioId = parentData.portfolioId;
            if(parentData.portfolioId && Number(portfolioId) && !parentData.isSmartFiltered){
                portfolioIdList.push(portfolioId);
            }
        });

        this.removeSelected(portfolioIdList);
        this.clearAutoFilter();
    }

    delete(cc: any) {
        this.removeSelected([cc.portfolioId]);
    }

    removeSelected(portfolioIdList:Array<any>){
        let d: any = [];

        portfolioIdList.forEach((portfolioId: any) => {
            const selectedGroup = this.grid.api.getRowNode(portfolioId);

            if (selectedGroup) {
                const currentRecord = selectedGroup.data;

                if(!currentRecord.isNew && !currentRecord.isSmartFiltered) {
                    currentRecord.isUIdeleted = true;
                    delete currentRecord.portfolioNameGroup;
                    delete currentRecord.extraCashAmount;
                    this.deletedRecords.push(currentRecord);
                }
            }

            if(this.hideImportExtraCashAndColDefs) {
                d = d.concat(this.getGroupRows(selectedGroup));
            } else {
                d.push(selectedGroup.data);
            }
        });

        this.grid.api.applyTransaction({ remove: d });

        setTimeout(() => {
            this.packdata();
            this.dataChange.emit(this.data);
            this.setRowCount();
            this.updateGridHeight();
            this.setExpandedorCollapsedAll();
        });
    }

    getGroupRows(node:any){
        let res:Array<any> = [];
        if (node && node.childrenAfterGroup && Array.isArray(node.childrenAfterGroup)) {
            for (let i = 0; i < node.childrenAfterGroup.length; i++) {
                res = res.concat(this.getGroupRows(node.childrenAfterGroup[i]));
            }
        }
        return node.data ? res.concat([node.data]) : res;
    }

    cancelDelete() {
        this.ctas.remove();
    }

    isExternalFilterPresent() {
        return true;
    }

    doesExternalFilterPass(node: any) {
        return node && node.data && !node.data.isUIdeleted;
    }

    getRowCount() {
        return  this.rowCount;
    }

    setRowCount(){
        // this.grid.api.collapseAll(); // to get only level 1 row count.
        if(this.data.isUIAllPort){
            this.rowCountText = "Included Portfolios"
        }else{
            //portfolio.portfolioId + 'TempChild'
            let count = 0;
            if (this.grid && this.grid.api) {
                this.grid.api.forEachNode((rowNode: any) => {
                    if (rowNode.level === 0) {
                        count++;
                    }
                });
            }
            this.rowCount = count;
            this.rowCountText = this.rowCount + "  " + "Included Portfolios";
        }
    }


    addPortFolioToGrid() {
        this.grid.api.showLoadingOverlay();
        this.portfolioIds = [];
        const dupelems: any = [];

        this.portfolioTargets.forEach((newsec: any) => {
            const selectedGroup = this.grid.api.getRowNode(newsec.value);
            if (selectedGroup) {
                if(selectedGroup.data.isUIdeleted) {
                    selectedGroup.data.isUIdeleted = false;
                } else {
                    dupelems.push(newsec);
                }
            } else {
                this.portfolioIds.push(newsec.value);
            }
        });
        if (dupelems.length > 0) {
            this.as.fireEvent(IrbAppEvents.SHOW_TOAST, {
                severity: "warn",
                summary: "",
                detail: "Portfolios cannot be listed twice"
            });
        }

        this.ies.getPortfoliosRebal(this.portfolioIds).subscribe((data: any) => {
            this.as.fireEvent(IrbAppEvents.SHOW_WAIT);
            this.checkGetPortfoliosRebal(data.responseUtilityMap.statusId);
        }, () => {});

        this.portfolioTargets = [];
        this.portfolioDropdown.clear();         
    }

    checkGetPortfoliosRebal(rprasId: string) {
        this.checkGetPortfoliosRebalSub = interval(3000).subscribe(() => {
            this.ies.getPortfoliosRebalStatus(rprasId).subscribe((response: any) => {
                if(response.responseUtilityMap.requestStatus.toUpperCase() == "COMPLETED") {
                    this.checkGetPortfoliosRebalSub.unsubscribe();
                    this.completeGetPortfoliosRebal({
                        responseStatus: "SUCCESS",
                        responseData: JSON.parse(response.responseData)
                    } as any);
                } else if(response.responseUtilityMap.requestStatus.toUpperCase() == "FAILED") {
                    this.as.fireEvent(IrbAppEvents.SHOW_ALERT, {
                        dType: 'ERROR',
                        dTitle: '',
                        dProceedBtnLabel: '',
                        msg: response.failMsg,
                        onProceed: () => {}
                    } as IAlertDialogData);
                    this.checkGetPortfoliosRebalSub.unsubscribe();
                    this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
                } else if(response.responseUtilityMap.requestStatus.toUpperCase() == "INPROGRESS") {
                }
            });
        });
    }

    completeGetPortfoliosRebal(data: any) {
        if (data?.responseStatus === 'SUCCESS') {
            this.load(data.responseData);
            this.packdata();
            this.dataChange.emit(this.data);
            setTimeout(() => {
                if (this.grid && this.grid.api) {
                    this.grid.api.hideOverlay();
                    this.updateGridHeight();
                }
            });  
            this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
        } else {
            this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
        }
    }

    addMultiplePortFoliosToGrid(selectedPortfolios: Array<IAnalysisPortfolioDTO>) {
        this.load(selectedPortfolios);
        this.packdata();
        this.dataChange.emit(this.data);

        setTimeout(() => {
            this.grid.api.hideOverlay();
            this.updateGridHeight();
        });
    }

    refreshForImportLossPrioritySettings(data: any) {
        this.grid.api.showLoadingOverlay();

        if (data.data.responseData.analysisPortDtoList.length > 0) {
            data.data.responseData.analysisPortDtoList.forEach((portfolio: any) => {
                const selectedGroup = this.grid.api.getRowNode(portfolio.portfolioId);

                if(!selectedGroup){
                    portfolio['portfolioNameGroup'] = [portfolio.portfolioName];
                    portfolio.isNew = true;
                    this.grid.api.applyTransaction({add:[portfolio]});
                } else {
                    selectedGroup.data.isUIdeleted = false;
                    selectedGroup.data.htlAmount = portfolio.htlAmount;
                    selectedGroup.data.lossPrty = portfolio.lossPrty;
                    selectedGroup.data.analysisAccountDtoList = portfolio.analysisAccountDtoList;
                    this.grid.api.applyTransaction({update:[selectedGroup]});
                }
            });
        }

        this.setRowCount();
        this.packdata();
        this.dataChange.emit(this.data);
        this.grid.api.hideOverlay();
        this.updateGridHeight();
    }

    addSmartFilterPortfolios() {
        if (this.data?.smartFilterDto.smartFilterDays != null) {
            if (!(this.data?.smartFilterDto.smartFilterDays >=1 && this.data?.smartFilterDto.smartFilterDays < 1000)) {
                return;
            }
        }

        this.grid.api.showLoadingOverlay();

        this.data.smartFilterDto.analysisPortDtoList = [];
        this.data.smartFilterDto.modelUpdated = (typeof this.modelUpdated === "undefined") ? false : this.modelUpdated;
        this.data.smartFilterDto.sfModelDtoList = this.modelIds;
        this.data.smartFilterDto.sfCategoryDtoList = this.categoryIds;
        this.data.smartFilterDto.isModelAll = this.data.smartFilterDto.sfModelDtoList?.length === this.modelDropdownData.length;
        this.data.smartFilterDto.isCategoryAll = this.data.smartFilterDto.sfCategoryDtoList?.length === this.categoryDropdownData.length;
        this.data.smartFilterDto.isModelBlank = this.isModelBlank;
        this.data.smartFilterDto.isCategoryBlank = this.isCategoryBlank;
        this.data.smartFilterDto.sfModelDtoList = (this.data.smartFilterDto.isModelAll) ? [] : this.data.smartFilterDto.sfModelDtoList;
        this.data.smartFilterDto.sfCategoryDtoList = (this.data.smartFilterDto.isCategoryAll) ? [] : this.data.smartFilterDto.sfCategoryDtoList;

        this.ies.getSmartFilterDetails(this.data.smartFilterDto).subscribe((data: any) => {
            if(data.responseStatus !== "EXCEPTION") {
                const responseArray = data.responseData;
                const portfolioIdList: any = [];

                this.grid.api.forEachNode((rowNode:any) => {
                    const parentData = rowNode.data;
                    const portfolioId = parentData.portfolioId;

                    if(portfolioId && parentData.isSmartFiltered){
                        portfolioIdList.push(portfolioId);
                    }
                });

                this.removeSelected(portfolioIdList);
                this.load(responseArray);
                this.packdata();
                this.dataChange.emit(this.data);
                setTimeout(() => {
                    if (this.grid && this.grid.api) {
                        this.grid.api.hideOverlay();
                        this.updateGridHeight();
                        this.setOverlayNoRowsTemplate();
                    }
                });
            } else {
                let m = 'Smart filter for included portfolios failed';
                m += ' Category List=' + JSON.stringify(this.data.smartFilterDto.sfCategoryDtoList);
                m += ' Model List=' + JSON.stringify(this.data.smartFilterDto.sfModelDtoList);
                if (!this.isUnitTest)
                    throw new Error(m);
            }
        });
    }

    clearAutoFilter(){
        this.grid.api.showLoadingOverlay();
        this.categoryTargets = [];
        this.modelTargets = [];
        this.modelIds = [];
        this.categoryIds = [];
        this.modelUpdated = false;
        this.isModelBlank = false;
        this.isCategoryBlank = false;
        this.data.smartFilterDto.smartFilterDays = null;
        this.data.smartFilterDto.modelUpdated = false;
        this.addSmartFilterPortfolios();
    }
    setOverlayNoRowsTemplate() {
        if(this.rowCount === undefined || this.rowCount === null || this.rowCount === 0 ) {
            if (this.gridOptions && this.grid.api) {
                this.gridOptions.overlayNoRowsTemplate = "No records found.";
                this.grid.api.showNoRowsOverlay();
            }
        }
    }
    frozenAccountAlertDialog(accountNumber:number): void {
        this.as.fireEvent(IrbAppEvents.SHOW_ALERT, {
            dTitle: 'Frozen Account',
            msg: "Account "+accountNumber+" is marked 'Frozen'. If you proceed to liquidate this account, the 'Frozen' flag will be overridden for this rebalance"
        } as IAlertDialogData);
    }

    refreshForImportExtraCashSettings(data: any) {
        this.grid.api.showLoadingOverlay();

        if (data.data.responseData.analysisPortDtoList.length > 0) {
            data.data.responseData.analysisPortDtoList.forEach((portfolio: any) => {
                const selectedGroup = this.grid.api.getRowNode(portfolio.portfolioId);

                if(!selectedGroup){
                    portfolio['extraCashAmount'] = portfolio.pfExtraCash;
                    portfolio['portfolioNameGroup'] = [portfolio.portfolioName];
                    this.grid.api.applyTransaction({add:[portfolio]});
                }

                const TempChild = this.grid.api.getRowNode(portfolio.portfolioId + 'TempChild');

                if(TempChild){
                    this.applyTransactionAsync({remove:[TempChild.data]},false);
                }

                portfolio.analysisAccountDtoList.forEach((account: any) => {
                        if(!account.extraCashAmount){
                            account['extraCashAmount'] = null;
                        }

                        account['portfolioNameGroup'] = [portfolio.portfolioName, account.accountNumber];
                        let isPresent = false;
                    let reDrawNode = null;
                        this.grid.api.forEachNode((rowNode: any) => {
                            if(rowNode.data.accountId === account.accountId) {
                                isPresent = true;
                                reDrawNode = rowNode;
                                reDrawNode.data.extraCashAmount = account.extraCashAmount;
                            }
                        });

                        if(isPresent) {
                            this.grid.api.redrawRows({rowNodes: [reDrawNode]});
                            this.grid.api.applyTransaction({update: [account]});
                        } else {
                            this.grid.api.applyTransaction({add:[account]});
                        }
                });
            });
        }
        
        this.setRowCount();
        this.packdata();
        this.dataChange.emit(this.data);
        this.grid.api.hideOverlay();
        this.updateGridHeight();
    }
    expandAll() {
        if(this.grid && this.grid.api && !this.isExpandedAll) {
            this.grid.api.expandAll();
        }
        this.setExpandedorCollapsedAll();
    }
    collapseAll() {
        if(this.grid && this.grid.api && !this.isCollapsedAll) {
            this.grid.api.collapseAll();
        }
        this.setExpandedorCollapsedAll();
    }
    setExpandedorCollapsedAll() {
        this.isExpandedAll = true;
        this.isCollapsedAll = true;
        this.grid.api.forEachNode((node:any)=>{
            if(node.childrenAfterGroup && node.childrenAfterGroup.length > 0) {
                this.isExpandedAll = this.isExpandedAll  && node.expanded;
                this.isCollapsedAll = this.isCollapsedAll && !node.expanded;
            }
        });
        this.updateGridHeight();
    }
    onIncludedPortfoliosGridCellClicked(event: CellClickedEvent) {
        if(event.column.getColId() === 'accountNumber') {
            if(event.node.isExpandable() && event.node.expanded) {
                event.node.setExpanded(false);
            } else if (event.node.isExpandable() && !event.node.expanded) {
                event.node.setExpanded(true);
            }
            this.updateGridHeight();
        }
    }

    cellValueTLHChanged(params: CellValueChangedEvent<any, any>) {
        if (params.colDef.field === 'lossPrty') {
            if (params.oldValue !== params.newValue) {
                this.dataChange.emit(true);
            }
        }

    }
}
